import React from 'react'

const ModalProject=(props)=>{
  
  const closeModal=(e)=>{
    console.log(e.target)
    let modal=document.getElementById(`modal${props.id}`)
    console.log(modal)
    modal.classList.remove('active')

    modal.classList.remove('back-video')
  }

  return (
    <div id={`modal${props.id}`} className="modal">
      <div className="modal-container">
        <div className="modal-image-container">
          <div id='close' onClick={closeModal.bind(this)}  className="modal-remove"><img src="/media/icons/close.svg" alt="cerrar"/></div>
        </div>
        <div className="modal-body">
          <div className="modal-text">
            <p>{props.longDescription}</p>
          </div>
          <div className="modal-info">
            <p className='modal-tools'>{props.tools}</p>
            <div className="line"></div>
              <a className='modal-link' href={props.url} target="_blank" rel="noopener noreferrer">Link al Proyecto</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalProject
